import { Fragment, type ReactNode } from 'react';
import { Link } from 'react-router-dom';

/**
 * Managed copy carries a two-token mini-markup instead of HTML: `**bold**`
 * becomes <strong>, `[text](/path)` becomes a router <Link> (internal paths
 * only — anything else renders as plain text). `{name}` is replaced from
 * `vars` before parsing, so a forecast sentence can say "{high}°F" and stay
 * right when the numbers are refreshed. Nothing here is ever injected as HTML.
 */
export function substituteVars(text: string, vars?: Record<string, string | number>): string {
  if (!vars) return text;
  return text.replace(/\{(\w+)\}/g, (whole, key: string) => (key in vars ? String(vars[key]) : whole));
}

const TOKEN = /\*\*([^*]+)\*\*|\[([^\]]+)\]\((\/[^)\s]*)\)/g;

export function renderRich(text: string, vars?: Record<string, string | number>): ReactNode[] {
  const source = substituteVars(text, vars);
  const out: ReactNode[] = [];
  let last = 0;
  let i = 0;
  for (const m of source.matchAll(TOKEN)) {
    const at = m.index ?? 0;
    if (at > last) out.push(<Fragment key={i++}>{source.slice(last, at)}</Fragment>);
    if (m[1] !== undefined) out.push(<strong key={i++}>{m[1]}</strong>);
    else
      out.push(
        <Link key={i++} to={m[3]}>
          {m[2]}
        </Link>,
      );
    last = at + m[0].length;
  }
  if (last < source.length) out.push(<Fragment key={i++}>{source.slice(last)}</Fragment>);
  return out;
}

interface Props {
  text: string;
  vars?: Record<string, string | number>;
}

export default function Rich({ text, vars }: Props) {
  return <>{renderRich(text, vars)}</>;
}
